import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'spacersTag',
  title: 'Spacers Tag',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (Rule) => Rule.required(),
      description: 'Internal identifier for the spacers tag',
    }),
    defineField({
      name: 'displayName',
      title: 'Display Name',
      type: 'string',
      validation: (Rule) => Rule.required().max(25),
      description: 'Name displayed on fitment listings (max 25 characters)',
    }),
    defineField({
      name: 'filterName',
      title: 'Filter Name',
      type: 'string',
      validation: (Rule) => Rule.max(25),
      description:
        'Name shown in fitment guide filter dropdowns (max 25 characters)',
    }),
    defineField({
      name: 'frontSpacerDescription',
      title: 'Front Spacer Description',
      type: 'text',
      description:
        'Description for front spacers. Available merge fields: {{frontSpacer}}, {{rearSpacer}}, {{frontSpacerReason}}, {{rearSpacerReason}}',
    }),
    defineField({
      name: 'rearSpacerDescription',
      title: 'Rear Spacer Description',
      type: 'text',
      description:
        'Description for rear spacers. Available merge fields: {{frontSpacer}}, {{rearSpacer}}, {{frontSpacerReason}}, {{rearSpacerReason}}',
    }),
    defineField({
      name: 'squareFitDescription',
      title: 'Front&Rear Spacers Description',
      type: 'text',
      description:
        'Description when front and rear spacers are the same. Available merge fields: {{frontSpacer}}, {{rearSpacer}}, {{frontSpacerReason}}, {{rearSpacerReason}}',
    }),
    defineField({
      name: 'warning',
      title: 'Warning',
      type: 'text',
      description:
        'Warning message displayed with spacer information. Uses data from recommended tire size. Available merge fields: {{frontSpacer}}, {{rearSpacer}}, {{frontSpacerReason}}, {{rearSpacerReason}}',
    }),
    defineField({
      name: 'isFilterable',
      title: 'Filterable',
      type: 'boolean',
      initialValue: true,
      description: 'Show this tag in fitment guide filters',
    }),
    defineField({
      name: 'isModification',
      title: 'Is Modification',
      type: 'boolean',
      initialValue: true,
      description: 'Show under "Acceptable Modifications" section in filters',
    }),
    defineField({
      name: 'isHidden',
      title: 'Hidden',
      type: 'boolean',
      initialValue: false,
      description:
        'Hide the tag label from the UI while still showing the description',
    }),
    defineField({
      name: 'order',
      title: 'Order',
      type: 'number',
      description: 'Display order in filters (lower numbers appear first)',
    }),
    defineField({
      name: 'penaltyScore',
      title: 'Penalty Score',
      type: 'number',
      description:
        'Points deducted from "Ease of fit" score when this tag is applied. Higher penalties indicate more difficult fitments. Maximum penalty is 10 points.',
      validation: (Rule) => Rule.min(0).max(10).precision(1),
      initialValue: 0,
    }),
  ],
  preview: {
    select: {
      title: 'name',
      displayName: 'displayName',
    },
    prepare({ title, displayName }) {
      return {
        title: displayName || title,
        subtitle: `Spacers Tag: ${title}`,
      }
    },
  },
})
